import { createSlice } from "@reduxjs/toolkit";
import { fetchOrder } from "../actions/orders";

const orderSlice = createSlice({
  name: "order",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {
    clearOrder: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrder.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearOrder } = orderSlice.actions;
export default orderSlice.reducer;
